import {Component, ElementRef, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {WidgetConfig} from '../../../_models/WidgetConfig';

@Component({
  selector: 'app-widget-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  @Input() config?: WidgetConfig<any>;
  @Output() maximized = new EventEmitter<boolean>();
  @Output() openedInNew = new EventEmitter();
  @Output() closed = new EventEmitter<Event>();

  isMaximized = false;

  constructor(private elRef: ElementRef) {
  }

  ngOnInit(): void {
  }

  maximize(): void {
    this.isMaximized = !this.isMaximized;
    this.maximized.emit(this.isMaximized);

    /*const gridsterItem: GridsterItem = this.elRef.nativeElement.parentElement.parentElement;
    if (gridsterItem) {
      if (this.isMaximized) {
        gridsterItem.classList.add('gridster-item-resizable');
      } else {
        gridsterItem.classList.remove('gridster-item-resizable');
      }
    }*/
  }

  openInNew(): void {
    this.openedInNew.emit();
  }

  close(event: Event): void {
    this.closed.emit(event);
  }
}
